import { ComponentProps } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import { TagsInput } from '@/components/tags-input';

import { DefaultFormField, FormFieldProps } from './default-form-field';

type TagsFormFieldControlProps = Omit<
  ComponentProps<typeof TagsInput>,
  'disabled' | 'onBlur' | 'onValueChange' | 'value'
>;

export function TagsFormField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  control,
  name,
  disabled,
  label,
  description,
  hideError,
  ...props
}: FormFieldProps<TagsFormFieldControlProps, TFieldValues, TName>) {
  return (
    <DefaultFormField
      control={control}
      name={name}
      label={label}
      description={description}
      hideError={hideError}
      disabled={disabled}
      render={({ field }) => (
        <TagsInput
          {...props}
          value={Array.isArray(field.value) ? field.value : []}
          onValueChange={field.onChange}
          onBlur={field.onBlur}
          disabled={field.disabled}
        />
      )}
    />
  );
}
